import { render, staticRenderFns } from "./HistoricalAchievements.vue?vue&type=template&id=a725dd4a&scoped=true"
import script from "./HistoricalAchievements.vue?vue&type=script&lang=js"
export * from "./HistoricalAchievements.vue?vue&type=script&lang=js"
import style0 from "./HistoricalAchievements.vue?vue&type=style&index=0&id=a725dd4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a725dd4a",
  null
  
)

export default component.exports